// Librerias
import React, { useState, useEffect } from "react";
import { Dropdown, Label, Grid, Button, Form, Icon, Checkbox } from "semantic-ui-react";
import { filter, isEmpty, map, includes, isEqual, toLower, get, reject, trim } from "lodash";
import Joi from "joi";
import PropTypes from "prop-types";
import moment from "moment";

// Utils
import { dropdownFormat } from "@Utils/formats";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";
import dataHandler from "@Utils/dataHandler";

// Utils
import { getExcludingNulls } from "@Utils/index";

// Components
import Input from "@Components/Input";
import Text from "@Components/Text";
import NewTable from "@Components/NewTable";
import IKModal from "@Components/IkModal";
import HoursDays from "@Components/HoursDays";
import AddHoliDay from "@Features/CompanyMaster/Modals/SettingCrud/AddHoliDay";

// Modals
import ConfirmModal from "@Modals/ConfirmModal";
import AlertTimes from "@Modals/AlertTimes";

// Styles
import styles from "./styles.module.css";

const GroupCrud = ({
	// watchOnly = false,
	tableValue,
	apiData,
	onClose,
	group,
	dispatch,
	presetMessages,
	alerts,
	types,
	modalCrud,
	companyId,
	saveOption,
	groupsHandler,
	currentCompanyId,
	bots,
}) => {
	const schema = Joi.object().keys({
		nombreGroup: Joi.string().min(4).messages({
			"string.min": "Nombre debe tener mínimo 4 caracteres",
			"string.empty": "Nombre es un campo requerido",
		}),
		nombreGroupRepet: Joi.string().messages({
			"string.empty": "El Título ya existe",
		}),
		types: Joi.number().min(0).messages({
			"number.base": "Tipo es un campo requerido",
		}),
	});
	const [alertItem, setAlertItem] = useState({});
	const [openAlertTimes, setOpenAlertTimes] = useState(false);
	const [predTimeOutData, setPredTimeOutData] = useState([]);
	const [predCloseData, setPredCloseData] = useState([]);
	const [predBeginData, setPredBeginData] = useState([]);
	const [predWelcomeData, setPredWelcomeData] = useState([]);
	const [botsData, setBotsData] = useState([]);
	const [open, setOpen] = useState(false);
	const [typesData, setTypesData] = useState([]);
	const [errors, setErrors] = useState({ nombreGroup: "", nombreGroupRepet: "", types: "" });
	const [initialFormData, setInitialFormData] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [stateHeader, setStateHeader] = useState("basicInfo");
	const [schedules, setSchedules] = useState([]);
	const [alwaysOpen, setAlwaysOpen] = useState(false);
	const [savedSchedules, setSavedSchedules] = useState([]);
	const [isHours, setIsHours] = useState(true);
	const [schedulesFeriados, setSchedulesFeriados] = useState([]);
	const [openAddHoliDay, setOpenAddHoliDay] = useState(false);
	const [itemEditHoliDay, setItemEditHoliDay] = useState({});
	const [holidayToDelete, setHolidayToDelete] = useState([]);
	const [chatEnter, setChatEnter] = useState(false);
	const [useSchedule, setUseSchedule] = useState(false);
	const [alertsToDelete, setAlertsToDelete] = useState({});
	const [openAlertsDelete, setOpenAlertsDelete] = useState(false);
	const [formData, setFormData] = useState({
		nombreGroup: "",
		types: "",
		predWelcome: [],
		predBegin: [],
		predClose: [],
		predTimeOut: [],
		bots: "",
		alerts: [],
		chatEnter: false,
		useSchedule: false,
		schedule: [],
		holidays: [],
	});

	useEffect(() => {
		(async () => {
			let groups = {};
			if (tableValue.id) {
				const groupPromise = dataHandler({
					dispatch,
					url: `groups/${tableValue.id}`,
					// params: defaultParams,
				});

				[groups] = await Promise.all([groupPromise]);
			}

			setModalOption(modalCrud);
			dropDownData();
			setBotsData(dropdownFormat(bots || [], "name", "id"));
			let shecdulesFormatted = get(groups, "schedule", []);

			if (!isEmpty(groups.schedule)) {
				shecdulesFormatted = map(groups.schedule, (item) => {
					return {
						...item,
						days: getExcludingNulls(item, "day", ""),
						beginTime: getExcludingNulls(item, "startHour", "").slice(0, 5) || "",
						endTime: getExcludingNulls(item, "endHour", "").slice(0, 5) || "",
					};
				});
			}

			setInitialFormData({
				nombreGroup: get(groups, "name", ""),
				types: get(groups, "typeId", ""),
				predWelcome: Array.isArray(get(groups, "settings.welcomeMessageId"))
					? get(groups, "settings.welcomeMessageId")
					: get(groups, "settings.welcomeMessageId")
					? [get(groups, "settings.welcomeMessageId")]
					: [],
				predBegin: Array.isArray(get(groups, "settings.startMessageId"))
					? get(groups, "settings.startMessageId")
					: get(groups, "settings.startMessageId")
					? [get(groups, "settings.startMessageId")]
					: [],
				predClose: Array.isArray(get(groups, "settings.closeMessageId"))
					? get(groups, "settings.closeMessageId")
					: get(groups, "settings.closeMessageId")
					? [get(groups, "settings.closeMessageId")]
					: [],
				predTimeOut: Array.isArray(get(groups, "settings.outOfScheduleMessageId"))
					? get(groups, "settings.outOfScheduleMessageId")
					: get(groups, "settings.outOfScheduleMessageId")
					? [get(groups, "settings.outOfScheduleMessageId")]
					: [],
				bots: get(groups, "botId", ""),
				alerts: get(groups, "settings.alerts", alerts),
				chatEnter: get(groups, "settings.chatEnter", false),
				useSchedule: get(groups, "settings.useSchedule", false),
				alwaysOpen: false,
				schedule: shecdulesFormatted, // Usar el formato transformado en lugar del original
				holidays: get(groups, "holidays", []),
				holidaysD: [],
			});

			setFormData({
				nombreGroup: get(groups, "name", ""),
				types: get(groups, "typeId", ""),
				predWelcome: Array.isArray(get(groups, "settings.welcomeMessageId"))
					? get(groups, "settings.welcomeMessageId")
					: get(groups, "settings.welcomeMessageId")
					? [get(groups, "settings.welcomeMessageId")]
					: [],
				predBegin: Array.isArray(get(groups, "settings.startMessageId"))
					? get(groups, "settings.startMessageId")
					: get(groups, "settings.startMessageId")
					? [get(groups, "settings.startMessageId")]
					: [],
				predClose: Array.isArray(get(groups, "settings.closeMessageId"))
					? get(groups, "settings.closeMessageId")
					: get(groups, "settings.closeMessageId")
					? [get(groups, "settings.closeMessageId")]
					: [],
				predTimeOut: Array.isArray(get(groups, "settings.outOfScheduleMessageId"))
					? get(groups, "settings.outOfScheduleMessageId")
					: get(groups, "settings.outOfScheduleMessageId")
					? [get(groups, "settings.outOfScheduleMessageId")]
					: [],
				bots: get(groups, "botId", ""),
				alerts: get(groups, "settings.alerts", alerts),
				chatEnter: get(groups, "settings.chatEnter", false),
				useSchedule: get(groups, "settings.useSchedule", false),
				schedule: shecdulesFormatted, // Usar el formato transformado también aquí
				holidays: get(groups, "holidays", []),
			});
			// setAlwaysOpen(get(groups, "settings.alwaysOpen", false));
			setSchedules(shecdulesFormatted);
			setSchedulesFeriados(get(groups, "holidays", []));
			setChatEnter(get(groups, "settings.chatEnter", false));
			setUseSchedule(get(groups, "settings.useSchedule", false));
		})();
	}, []);

	// modal
	const cancelModal = () => {
		onClose();
	};

	// Función para verificar si hay cambios reales en el formulario
	const hasFormChanges = () => {
		// Comparar campos básicos del formData
		const basicFieldsChanged = !isEqual(
			{
				nombreGroup: initialFormData.nombreGroup,
				types: initialFormData.types,
				predWelcome: initialFormData.predWelcome,
				predBegin: initialFormData.predBegin,
				predClose: initialFormData.predClose,
				predTimeOut: initialFormData.predTimeOut,
				bots: initialFormData.bots,
				alerts: initialFormData.alerts,
			},
			{
				nombreGroup: formData.nombreGroup,
				types: formData.types,
				predWelcome: formData.predWelcome,
				predBegin: formData.predBegin,
				predClose: formData.predClose,
				predTimeOut: formData.predTimeOut,
				bots: formData.bots,
				alerts: formData.alerts,
			}
		);

		// Comparar estados locales
		const localStatesChanged =
			chatEnter !== initialFormData.chatEnter || useSchedule !== initialFormData.useSchedule || alwaysOpen !== initialFormData.alwaysOpen;

		// Comparar holidays
		const holidaysChanged = !isEqual(schedulesFeriados, initialFormData.holidays);

		// Comparar schedules usando la misma lógica de normalización
		const normalizeSchedule = (schedule) => {
			return schedule
				.filter((item) => {
					return item.beginTime || item.endTime || item.id;
				})
				.map((item) => {
					return {
						id: item.id || null,
						days: item.days || "",
						beginTime: item.beginTime || "",
						endTime: item.endTime || "",
					};
				});
		};

		const currentScheduleNormalized = normalizeSchedule(schedules);
		const initialScheduleNormalized = normalizeSchedule(initialFormData.schedule);
		const schedulesChanged = !isEqual(currentScheduleNormalized, initialScheduleNormalized);

		return basicFieldsChanged || localStatesChanged || holidaysChanged || schedulesChanged;
	};

	const modalOpen = () => {
		if (!hasFormChanges()) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	// Input
	const dropDownData = () => {
		const filterMsjPredWelcome = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Bienvenida")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		const filterMsjPredBegin = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Inicio")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		const filterMsjPredClose = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Cierre")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		const filterMsjPredTimeOut = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Fuera de Horario")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		const filterTypes = filter(types, (item) => {
			let valueFilter = false;
			if (includes(item.restriction, "groups")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		setTypesData(dropdownFormat(filterTypes, "name", "id"));
		setPredBeginData(dropdownFormat(filterMsjPredBegin, "title", "id"));
		setPredCloseData(dropdownFormat(filterMsjPredClose, "title", "id"));
		setPredTimeOutData(dropdownFormat(filterMsjPredTimeOut, "title", "id"));
		setPredWelcomeData(dropdownFormat(filterMsjPredWelcome, "title", "id"));
	};

	const handleInputDropdown = (event, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};
	const handleInputDropdownCategory = (event, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};
	const handleInput = (e) => {
		const { name, value } = e.target;

		setFormData({
			...formData,
			[name]: value,
		});
	};

	// modal Alert
	const tableAlertTimesHandler = (name, item) => {
		if (name === "Edit") {
			setAlertItem(item);
			setOpenAlertTimes(true);
		}
	};
	const alertTimesHandler = (item) => {
		const filterAlerts = [...reject(formData.alerts, { name: item.name }), item];
		setFormData({
			...formData,
			alerts: filterAlerts,
		});
	};

	// save handle
	const actionsHandler = async (data) => {
		if (modalOption === "Add") {
			const dataAdd = await dispatch(genericAction({ method: "post", route: "groups", body: data }));
			if (!isEmpty(dataAdd)) {
				setFormData({
					nombreGroup: "",
					types: "",
					predWelcome: "",
					predBegin: "",
					predClose: "",
					predTimeOut: "",
					bots: "",
					alerts: [],
					chatEnter: false,
					useSchedule: false,
					schedule: [],
					holidays: [],
				});
				apiData("Add");
			}
		} else {
			// Solo enviar si hay cambios reales
			const hasChanges = Object.keys(data).some((key) => {
				return key !== "companyId";
			});
			if (hasChanges) {
				const dataEdit = await dispatch(genericAction({ method: "patch", route: `groups/${tableValue.id}`, body: data }));
				if (!isEmpty(dataEdit)) {
					apiData("Edit");
				}
			} else {
				// No hay cambios, solo cerrar modal
				onClose();
			}
		}
	};
	const handlerSaved = () => {
		let nombreGroupRepet = "ejemplo";
		if (modalOption === "Add" && !companyId) {
			map(group, (item) => {
				if (!isEmpty(formData.nombreGroup)) {
					if (includes(toLower(item.name), toLower(formData.nombreGroup))) {
						nombreGroupRepet = "";
					}
				}
			});
		}

		if ((companyId || saveOption === "Add") && modalOption === "Add" && formData.nombreGroup) {
			const ListNameGroup = map(group, (item) => {
				return toLower(item.name);
			});
			if (includes(ListNameGroup, toLower(formData.nombreGroup))) {
				nombreGroupRepet = "";
			}
		}

		const validation = schema.validate(
			{
				nombreGroup: formData.nombreGroup,
				nombreGroupRepet,
				types: formData.types,
			},
			{ abortEarly: false }
		);
		if (validation.error) {
			const { details } = validation.error;

			let errorsData = {
				nombreGroup: "",
				nombreGroupRepet: "",
				types: "",
			};
			map(details, (item) => {
				errorsData = { ...errorsData, [item.context.key]: item.message };
			});
			setErrors(errorsData);
		} else {
			let nameValue = formData.nombreGroup;
			if (isEmpty(formData.nombreGroup)) {
				nameValue = null;
			}
			const typesVal = formData.types === "" || formData.types === null || formData.types === undefined ? null : Number(formData.types);
			const settings = {
				welcomeMessageId: !isEmpty(get(formData, "predWelcome", [])) ? get(formData, "predWelcome", []) : [],
				startMessageId: !isEmpty(get(formData, "predBegin", [])) ? get(formData, "predBegin", []) : [],
				closeMessageId: !isEmpty(get(formData, "predClose", [])) ? get(formData, "predClose", []) : [],
				outOfScheduleMessageId: !isEmpty(get(formData, "predTimeOut", [])) ? get(formData, "predTimeOut", []) : [],
				alerts: get(formData, "alerts", null),
				chatEnter,
				useSchedule,
				alwaysOpen,
			};
			const newSchedules = schedules
				.filter((item) => {
					return item.beginTime || item.endTime || item.id;
				})
				.map((item) => {
					return {
						...(item.id && { id: item.id }),
						day: item.days ? item.days.charAt(0).toUpperCase() + item.days.slice(1).toLowerCase() : null,
						startHour: item.beginTime ? moment(item.beginTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
						endHour: item.endTime ? moment(item.endTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
					};
				});

			// Construir el payload basado en cambios reales
			let data = {};

			// Comparar campos básicos
			if (trim(nameValue) !== trim(initialFormData.nombreGroup)) {
				data.name = trim(nameValue);
			}
			const initialTypesVal =
				initialFormData.types === "" || initialFormData.types === null || initialFormData.types === undefined
					? null
					: Number(initialFormData.types);
			if (typesVal !== initialTypesVal) {
				data.typeId = typesVal;
			}
			if ((formData.bots || null) !== (initialFormData.bots || null)) {
				data.botId = formData.bots || null;
			}

			// Comparar settings
			const initialSettings = {
				welcomeMessageId: !isEmpty(get(initialFormData, "predWelcome", [])) ? get(initialFormData, "predWelcome", []) : [],
				startMessageId: !isEmpty(get(initialFormData, "predBegin", [])) ? get(initialFormData, "predBegin", []) : [],
				closeMessageId: !isEmpty(get(initialFormData, "predClose", [])) ? get(initialFormData, "predClose", []) : [],
				outOfScheduleMessageId: !isEmpty(get(initialFormData, "predTimeOut", [])) ? get(initialFormData, "predTimeOut", []) : [],
				alerts: initialFormData.alerts,
				chatEnter: initialFormData.chatEnter,
				useSchedule: initialFormData.useSchedule,
				alwaysOpen: get(initialFormData, "alwaysOpen", false),
			};

			if (!isEqual(settings, initialSettings)) {
				data.settings = settings;
			}

			// Comparar horarios - normalizar ambos arrays antes de comparar
			const normalizeSchedule = (schedule) => {
				return schedule
					.filter((item) => {
						return item.beginTime || item.endTime || item.id;
					})
					.map((item) => {
						return {
							id: item.id || null,
							days: item.days || "",
							beginTime: item.beginTime || "",
							endTime: item.endTime || "",
						};
					});
			};

			const currentScheduleNormalized = normalizeSchedule(schedules);
			const initialScheduleNormalized = normalizeSchedule(initialFormData.schedule);

			// Comparar otros arrays
			if (!isEqual(schedulesFeriados, initialFormData.holidays)) {
				data.holidays = schedulesFeriados;
			}
			if (!isEqual(holidayToDelete, initialFormData.holidaysD || [])) {
				data.holidaysD = holidayToDelete;
			}
			if (!isEqual(currentScheduleNormalized, initialScheduleNormalized)) {
				data.schedule = newSchedules;
			}

			// Siempre incluir companyId para contexto
			if (companyId) {
				data = { ...data, companyId };
			} else {
				data = { ...data, companyId: currentCompanyId };
			}

			if (companyId || saveOption === "Add") {
				switch (saveOption) {
					case "Add":
						groupsHandler(data, modalOption, get(tableValue, "name"));
						setInitialFormData({
							nombreGroup: "",
							types: "",
							predWelcome: "",
							predBegin: "",
							predClose: "",
							predTimeOut: "",
							bots: "",
							alerts: [],
							chatEnter: false,
							useSchedule: false,
							alwaysOpen: false,
							schedule: [],
							holidays: [],
							holidaysD: [],
						});
						onClose();
						break;

					case "Edit":
						actionsHandler(data);
						setInitialFormData({
							nombreGroup: "",
							types: "",
							predWelcome: "",
							predBegin: "",
							predClose: "",
							predTimeOut: "",
							bots: "",
							alerts: [],
							chatEnter: false,
							useSchedule: false,
							alwaysOpen: false,
							schedule: [],
							holidays: [],
							holidaysD: [],
						});
						break;

					default:
						break;
				}
			} else {
				actionsHandler(data);
				setInitialFormData({
					nombreGroup: "",
					types: "",
					predWelcome: "",
					predBegin: "",
					predClose: "",
					predTimeOut: "",
					bots: "",
					alerts: [],
					chatEnter: false,
					useSchedule: false,
					alwaysOpen: false,
					schedule: [],
					holidays: [],
					holidaysD: [],
				});
			}

			setErrors({ nombreGroup: "", nombreGroupRepet: "", types: "" });
		}
	};

	const handleStateHeader = (states) => {
		setStateHeader(states);
	};

	const handleApplyToAllClear = () => {
		const updatedScheduleDataDays = schedules.map((item) => {
			return {
				...item,
				beginTime: "",
				endTime: "",
			};
		});
		setSchedules(updatedScheduleDataDays);
	};

	const handleApplyToAllAlwaysOpenFeriados = (action, item) => {
		switch (action) {
			case "Add":
				setOpenAddHoliDay(true);
				setItemEditHoliDay({});
				break;
			case "Edit":
				setItemEditHoliDay(item);
				setOpenAddHoliDay(true);
				break;
			case "Eraser": {
				setOpenAlertsDelete(true);
				setAlertsToDelete(item);
				break;
			}
			default:
				break;
		}
	};

	const renderAlertsDelete = (item) => {
		const updatedFeriados = reject(schedulesFeriados, (feriado) => {
			return feriado.id === item.id;
		});

		setSchedulesFeriados(updatedFeriados);
		setHolidayToDelete((prev) => {
			return [...prev, item.id];
		});
		setOpenAlertsDelete(false);
	};
	const isVisibleAction = (item) => {
		const today = new Date();
		const itemDate = new Date(item.date);

		if (today > itemDate) {
			return true;
		}
		if (!item.id) {
			return true;
		}
		return false;
	};

	const isVisibleActionD = (item) => {
		const today = new Date();
		const itemDate = new Date(item.date);

		if (today > itemDate) {
			return true;
		}

		return false;
	};
	const handleApplyToAllOpen = () => {
		const updatedScheduleDataDays = schedules.map((item) => {
			return {
				...item,
				beginTime: "00:00",
				endTime: "23:59",
			};
		});
		setSchedules(updatedScheduleDataDays);
	};

	const handleSaveHoliDay = (item) => {
		setSchedulesFeriados(item);
	};

	return (
		<>
			<IKModal
				title={modalOption === "Add" ? "Agregar Grupo" : `Grupo: ${get(tableValue, "name", "")} `}
				id={tableValue.id}
				mode={modalOption}
				setMode={setModalOption}
				onClose={modalOpen}
				onSuccess={handlerSaved}
				fullHeight
				size="large">
				<div className={styles.modalContent}>
					<div className={styles.divHeaderNav}>
						<div className={styles.basicInfo}>
							<Button
								className={stateHeader === "basicInfo" ? `${styles.navButton} ${styles.active}` : styles.navButton}
								onClick={() => {
									handleStateHeader("basicInfo");
								}}>
								Información
							</Button>
						</div>
						<div className={styles.divButtonPermissions}>
							<Button
								className={stateHeader === "schedules" ? `${styles.navButton} ${styles.active}` : styles.navButton}
								onClick={() => {
									handleStateHeader("schedules");
								}}>
								Horarios
							</Button>
						</div>
						{/* <div className={styles.classButtonHeader}></div> */}
					</div>
					<Grid className={styles.grid} stackable columns={2}>
						{stateHeader === "basicInfo" && (
							<Grid.Row className={styles.responsiveRow}>
								<Grid.Column width={8}>
									<fieldset className={styles.fieldset}>
										<legend className={styles.legend}>General</legend>
										<Text className={styles.textBox}>
											Tipo <span className={styles.required}>*</span>
										</Text>
										<Dropdown
											fluid
											placeholder="Seleccionar"
											value={formData.types}
											required
											size="mini"
											name="types"
											clearable
											disabled={modalOption === "Watch"}
											error={!isEmpty(errors.types) && { content: errors.types, pointing: "above" }}
											className={styles.input}
											search
											selection
											onChange={handleInputDropdownCategory}
											options={typesData}
										/>
										<Label className={styles.messageError} style={isEmpty(errors.types) ? { display: "none" } : null} pointing prompt>
											{errors.types}
										</Label>
										<Text className={styles.textBox}>
											Nombre: <span className={styles.required}>*</span>
										</Text>
										<Input
											value={formData.nombreGroup}
											icon="unordered list"
											// label="Nombre"
											required
											placeholder="Nombre"
											name="nombreGroup"
											disabled={modalOption === "Watch"}
											fluid
											error={
												!isEmpty(errors.nombreGroup) && {
													content: errors.nombreGroup,
													pointing: "above",
													className: styles.messageError,
												}
											}
											onChange={handleInput}
											className={styles.input}
										/>

										<Label
											className={styles.messageError}
											style={isEmpty(errors.nombreGroupRepet) ? { display: "none" } : null}
											pointing
											prompt>
											{errors.nombreGroupRepet}
										</Label>
									</fieldset>
									<fieldset className={styles.fieldsetMesAut}>
										<legend className={styles.legend}>Mensajes Automatizados</legend>

										<Text className={styles.textBox}>Bienvenida:</Text>
										<Dropdown
											className={styles.input}
											disabled={modalOption === "Watch" || saveOption === "Add"}
											required
											multiple
											placeholder="Elegir Mensaje"
											fluid
											clearable
											value={formData.predWelcome}
											name="predWelcome"
											search
											selection
											onChange={handleInputDropdown}
											options={predWelcomeData}
										/>

										<Text className={styles.textBox}>Inicio:</Text>
										<Dropdown
											className={styles.input}
											disabled={modalOption === "Watch" || saveOption === "Add"}
											required
											multiple
											placeholder="Elegir Mensaje"
											fluid
											clearable
											value={formData.predBegin}
											name="predBegin"
											search
											selection
											onChange={handleInputDropdown}
											options={predBeginData}
										/>

										<Text className={styles.textBox}>Cierre:</Text>
										<Dropdown
											className={styles.input}
											disabled={modalOption === "Watch" || saveOption === "Add"}
											required
											multiple
											placeholder="Elegir Mensaje"
											fluid
											clearable
											value={formData.predClose}
											name="predClose"
											search
											selection
											onChange={handleInputDropdown}
											options={predCloseData}
										/>

										<Text className={styles.textBox}>Fuera de Horario:</Text>
										<Dropdown
											className={styles.input}
											disabled={modalOption === "Watch" || saveOption === "Add"}
											required
											multiple
											placeholder="Elegir Mensaje"
											fluid
											clearable
											value={formData.predTimeOut}
											name="predTimeOut"
											search
											selection
											onChange={handleInputDropdown}
											options={predTimeOutData}
										/>
									</fieldset>
								</Grid.Column>

								<Grid.Column width={8}>
									<fieldset className={styles.fieldset}>
										<legend className={styles.legend}>Alertas</legend>
										<NewTable
											data={formData.alerts}
											columns={[
												{
													label: "Acciones",
													action: [{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" }],
													dataPosition: "center",
													width: 1,
													hidden: modalOption === "Watch",
												},
												{
													label: "Nombre",
													key: "name",
													format: "string",

													width: 1,
												},
												{
													label: "Color",
													key: "color",
													format: "label",
													colorLabel: [
														{ onName: "green", color: "green" },
														{ onName: "orange", color: "orange" },
														{ onName: "gold", color: "gold" },
														{ onName: "red", color: "red" },
													],
													width: 1,
												},
												{
													label: "Minutos",
													key: "time",
													format: "string",
													dataPosition: "center",
													width: 1,
												},
											]}
											defaultOrder={{ key: "name", dir: "asc" }}
											pageRows={100}
											handlerTable={tableAlertTimesHandler}
											haveFooter={false}
											searchPosition="left"
											mobileCardView
											cardLine1={[
												{ label: "", key: "name" },
												{
													label: "Color:",
													key: "color",
													format: "label",
													colorLabel: [
														{ onName: "green", color: "green" },
														{ onName: "orange", color: "orange" },
														{ onName: "gold", color: "gold" },
														{ onName: "red", color: "red" },
													],
												},
												{ label: "Minutos:", key: "time" },
											]}
										/>
									</fieldset>

									<fieldset className={styles.fieldsetSettings}>
										<legend className={styles.legend}>Configuraciones</legend>

										<div style={{ display: "flex", gap: "2rem", marginBottom: "15px" }}>
											<div>
												<Text className={styles.textBox}>Entrada de Chat:</Text>
												<Checkbox
													label={`${chatEnter ? "Si" : "No"}`}
													toggle
													checked={chatEnter}
													onChange={() => {
														setChatEnter(!chatEnter);
														setFormData((prev) => {
															return {
																...prev,
																chatEnter: !chatEnter,
															};
														});
													}}
													disabled={modalOption === "Watch"}
												/>
											</div>

											<div>
												<Text className={styles.textBox}>Utiliza Horario:</Text>
												<Checkbox
													label={`${useSchedule ? "Si" : "No"}`}
													toggle
													checked={useSchedule}
													onChange={() => {
														setUseSchedule(!useSchedule);
														setFormData((prev) => {
															return {
																...prev,
																useSchedule: !useSchedule,
															};
														});
													}}
													disabled={modalOption === "Watch"}
												/>
											</div>
										</div>

										<Text className={styles.textBox}>ChatBot:</Text>
										<Dropdown
											fluid
											placeholder="Seleccionar Bot"
											value={formData.bots}
											size="mini"
											name="bots"
											clearable
											disabled={modalOption === "Watch"}
											className={styles.input}
											search
											selection
											onChange={handleInputDropdownCategory}
											options={botsData}
										/>
									</fieldset>
								</Grid.Column>
							</Grid.Row>
						)}

						{stateHeader === "schedules" && (
							<Grid.Row className={styles.row2}>
								<Grid.Column width={16}>
									<fieldset className={styles.firstfieldset2}>
										<legend className={styles.legend}>
											<div className={styles.flexWidth}>
												<Icon className={styles.icon} name="clock outline" />
												<div>
													<span className={styles.legendFull}>Horario Lunes - Domingos</span>
													<span className={styles.legendShort}>Hor. Lun - Dom</span>
												</div>
												<Icon
													className={styles.iconEye}
													name={isHours ? "eye" : "eye slash"}
													onClick={() => {
														setIsHours(!isHours);
													}}
												/>

												<Form.Checkbox
													disabled={modalOption === "Watch"}
													checked={alwaysOpen}
													value={alwaysOpen}
													className={styles.checkboxContainer24}
													onChange={() => {
														if (!alwaysOpen) {
															setSavedSchedules(schedules);
															handleApplyToAllOpen();
														} else if (savedSchedules.length > 0) {
															setSchedules(savedSchedules);
														} else {
															handleApplyToAllClear();
														}
														setAlwaysOpen(!alwaysOpen);
													}}
													label="24 horas"
													width="8"
												/>
												<Icon
													className={styles.iconClear}
													name="trash"
													onClick={() => {
														setAlwaysOpen(false);
														handleApplyToAllClear();
													}}
												/>
											</div>
										</legend>

										<HoursDays
											scheduleData={schedules}
											setScheduleData={setSchedules}
											disabled={modalOption === "Watch"}
											isHours={isHours}
										/>
									</fieldset>
								</Grid.Column>

								<Grid.Column width={16}>
									<fieldset className={styles.fieldset}>
										<legend className={styles.legend}>Días Feriados - {schedulesFeriados.length}</legend>
										<NewTable
											data={schedulesFeriados}
											columns={[
												{
													label: "Acciones",
													action: [
														{
															content: "edit",
															color: "#3f7ea3",
															onClick: "Edit",
															type: "icon",
															hidden: modalOption === "Watch",
															isVisible: isVisibleAction,
														},
														{
															content: "trash",
															color: "#b43333",
															onClick: "Eraser",
															type: "icon",
															hidden: modalOption === "Watch",
															isVisible: isVisibleActionD,
														},
													],
													addButton: true,
													dataPosition: "center",
													width: 1,
													hidden: modalOption === "Watch",
												},
												{
													label: "Id",
													key: "id",
													format: "string",
													dataPosition: "center",
													width: 1,
												},
												{
													label: "Título",
													key: "name",
													format: "string",
													width: 3,
												},
												{
													label: "Fecha",
													key: "date",
													dataPosition: "center",
													format: "date",
													width: 1,
												},
												{
													label: "Hora Inicio",
													key: "startHour",
													dataPosition: "center",
													format: "time",
													width: 1,
												},
												{
													label: "Hora Fin",
													key: "endHour",

													format: "time",
													width: 1,
												},
												{
													label: "Mensaje Fuera de Horario",
													key: "message.title",
													format: "string",
													dataPosition: "left",
													headerPosition: "left",
													width: 15,
												},
											]}
											defaultOrder={{ key: "id", dir: "desc" }}
											pageRows={15}
											handlerTable={handleApplyToAllAlwaysOpenFeriados}
											haveFooter
											mobileCardView
											mobileAddButton
											cardLine1={[
												{ label: "ID:", key: "id" },
												{ label: "", key: "name" },
												{ label: "Fecha:", key: "date", format: "date" },
											]}
											cardLine2={[
												{ label: "Hora Inicio", key: "startHour", format: "time" },
												{ label: "Hora Fin", key: "endHour", format: "time" },
											]}
											cardLine3={[{ label: "Msj. Fuera de Hor", key: "message.title" }]}
										/>
									</fieldset>
								</Grid.Column>
							</Grid.Row>
						)}
					</Grid>
				</div>
			</IKModal>
			{open && (
				<ConfirmModal
					visible
					header="Salir del formulario"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
			{openAlertTimes && (
				<AlertTimes
					onClose={() => {
						return setOpenAlertTimes(false);
					}}
					alertTimesHandler={alertTimesHandler}
					tableValue={alertItem}
					data={formData.alerts}
				/>
			)}

			{openAddHoliDay && (
				<AddHoliDay
					open={openAddHoliDay}
					onClose={() => {
						setOpenAddHoliDay(false);
					}}
					onSave={handleSaveHoliDay}
					itemEditHoliDay={itemEditHoliDay}
					data={schedulesFeriados}
				/>
			)}
			{openAlertsDelete && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar salida"
					content="¿Estás seguro de querer eliminar este alerta"
					focus={alertsToDelete.name}
					buttonLabel="Eliminar"
					onConfirm={() => {
						renderAlertsDelete(alertsToDelete);
					}}
					onDismiss={() => {
						setOpenAlertsDelete(false);
					}}
				/>
			)}
		</>
	);
};

function mapStateToProps({ user, company }) {
	return {
		group: [],
		categoryArray: [],
		companyName: company.name,
		userName: user.name,
		alerts: company.settings.alerts,
		currentCompanyId: company.companyId,
	};
}

GroupCrud.propTypes = {
	tableValue: PropTypes.array,
	apiData: PropTypes.func,
	onClose: PropTypes.func,
	group: PropTypes.array,
	dispatch: PropTypes.func,
	presetMessages: PropTypes.array,
	alerts: PropTypes.array,
	types: PropTypes.array,
	companyId: PropTypes.number,
	saveOption: PropTypes.string,
	modalCrud: PropTypes.array,
	groupsHandler: PropTypes.func,
	currentCompanyId: PropTypes.number,
	bots: PropTypes.array,
};
export default connect(mapStateToProps)(GroupCrud);
